<template>
    <v-data-table :items="filteredItems"
                  :headers="cabeceras"
                  :hide-default-header="true"
                  :items-per-page="10"
                  class="elevation-1"
                  :sort-by="sortBy"
                  :sort-desc="sortDesc">

        <template v-slot:header="{ props: { headers } }">
            <thead>
                <tr class="blue-grey darken-4">
                    <th v-for="header in headers" :key="header.text" class="white--text" @click="changeSort(header.value)">
                        {{ header.text.replaceAll('_', ' ') }}
                    </th>
                </tr>
                <tr class="grey lighten-3">
                    <th class="white--text" v-for="header, index in headers" :key="header.text">
                        <div v-if="filtros.hasOwnProperty(header.value)">
                            <v-autocomplete v-model="filtros[header.value]" multiple clearable dense hide-details :items="columnValueList(header.value)"></v-autocomplete>
                        </div>
                    </th>
                </tr>
            </thead>
        </template>

        <template v-slot:item="{ item }">
            <tr>
                <template v-for="value, key, index in item">
                    <td v-if="excluded == undefined || !excluded.includes(key)" :key="key + '_' + index">{{ value }}</td>
                </template>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        props: {
            items: Array,
            excluded: Array,
            included: Array
        },

        data: () => ({
            sortBy: '',
            sortDesc: true,
            cabeceras: [],
            seleccionados: [],
            filtros: []
        }),

        computed: {
            filteredItems () {
                return this.items.filter(item => {
                    return Object.keys(this.filtros).every(filtro => {
                        return this.filtros[filtro].length < 1 || this.filtros[filtro].includes(item[filtro])
                    })
                })
            }
        },

        methods: {
            columnValueList(val) { return this.items.map(d => d[val]) },
            changeSort(column) {
                if (this.sortBy !== column) {
                    this.sortDesc = true
                    this.sortBy = column
                } else {
                    if (this.sortDesc) this.sortDesc = false
                    else this.sortBy = ''
                }
            }
        },

        created() {
            let cabeceras = this.cabeceras
            let filtros = this.filtros
            let excluded = this.excluded
            let included = this.included
            Object.keys(this.items[0]).forEach((key) => {
                if ((excluded == undefined || !excluded.includes(key)) && (included == undefined || included.includes(key))) {
                    cabeceras.push({ text: key, value: key })
                    this.$set(filtros, key, [])
                }
            })
        }
    }
</script>

<style>
    .v-data-table {
        -webkit-box-shadow: 0px 10px 13px -7px #000000, 1px 5px 15px 5px rgba(0,0,0,0);
        box-shadow: 0px 10px 13px -7px #000000, 1px 5px 15px 5px rgba(0,0,0,0);
    }

    thead tr.blue-grey {
        background-color: #263238;
    }
    .theme--light.v-data-table thead tr.blue-grey th {
        padding: 15px 0;
        color: white;
        font-size: 16px;
    }
    .v-data-table button {
        background-color: transparent;
    }

    .v-data-table tbody tr td {
        padding: 10px;
        font-size: 14px;
    }

    .v-data-footer {
        font-size: 14px;
    }
    .v-data-footer .v-input__control {
        margin: 0 18px;
    }
    .v-data-footer__select .v-select__selections .v-select__selection--comma {
        font-size: 14px;
    }
</style>